<template>
  <div class="form-box">
    <el-form ref="scopedForm" :model="scopedForm" :rules="rules" label-width="80px" v-if="ifForm==1">
      <el-form-item label="姓 名 :" prop="name">
        <el-input v-model="scopedForm.name"></el-input>
        <!-- <p class="scoped-tips">*姓名长度不超过16个字符</p> -->
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "editUserName",
  props: ["ifForm", "isCall", "params"],
  data () {
    return {
      rules: {
        name: [
          { required: true, message: '*请输入姓名', trigger: 'blur' },
          { min: 1, max: 16, message: '*姓名长度不超过16个字符', trigger: 'blur' }
        ],
      },
      scopedForm: {
        name: "",
      },
    };
  },
  components: {},
  watch: {
    isCall () {
      this.resetForm();
    }
  },
  created () {
    if (this.params) {
      this.scopedForm.name = this.params.name;
    }
    // console.log(this.params);
  },
  methods: {
    resetForm () {// 清空
      if (this.$refs.scopedForm) {
        this.$refs.scopedForm.resetFields();
      }
    },
    submit (callback) {// 提交
      var that = this;
      this.$refs.scopedForm.validate((valid) => {
        if (valid) {
          var params = {
            aliasName: this.scopedForm.name,
          };
          this.catReq1Service("/api/v1/user/update", params).then((response) => {
            if (!response.success) {
              return
            }
            callback && callback(this.scopedForm.name);
          }).catch((error) => {
          });
        } else {
          return false;
        }
      });
    },
    onSubmit () {
      // console.log(this.ifForm, "submit!");
    },
  }
};
</script>

<style lang="less" scoped>
.form-box {
  margin: 0 auto;
  width: 320px;
  text-align: left;
  padding: 0 50px;
}
.scoped-tips {
  padding-top: 6px;
  font-size: 12px;
  line-height: 12px;
  color: #999999;
}
</style>